import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '@common/services/AuthService/AuthService';

@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    private authService: AuthService,
    public router: Router,
  ) {}

  canActivate() {
    const canActivate = !!this.authService.getAccessToken();
    if (!canActivate) {
      this.router.navigateByUrl('/auth/login');
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/AuthGuardService/AuthGuardService.ts